import { map, filter, remove } from 'lodash';
import { createSlice, current } from '@reduxjs/toolkit';
import { EventInput } from '@fullcalendar/common';
import { dispatch } from '../store';
// utils
import { addDays } from 'date-fns';
import lodash from 'lodash';
import { axios } from '../../utils/axios';
//
import { CalendarState } from '../../@types/calendar';
// import { KanbanCard, KanbanColumn } from '../../@types/kanban';
function objFromArray<Type extends Record<string, any>>(array: Type[], key: string = 'id') {
  return array.reduce<Record<string, Type>>((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

// ----------------------------------------------------------------------
export type Resource = {
  driverID: number;
  avatar: string;
  name: string;
};
export type Slots = {
  slotName: string;
  data: SchedularJob[];
};
export type SchedularJob = {
  client: string;
  clientAddress: string;
  docketType: string;
  driverID: number;
  driverName: string;
  hazardous: boolean;
  jobID: number;
  jobStatus: number;
  dayType: string;
  serviceDate: string;
  occurrenceFrom: string;
  occurrenceTo: string;
  serviceDescription: string;
  serviceType: string;
  slotOrder: string;
  vehicleRegistration: string;
  vehicleType: string;
  wasteDetail: string;
};
export type Drivers = {
  driverID: string;
  driverName: string;
};
export type Vehicles = {
  registrationPlate: string;
  vehicleType: string;
};

type InitialState = {
  isLoading: boolean;
  error: boolean;
  selectedDate: Date;
  board: {
    resources: Resource[];
    jobs: SchedularJob[];
    slots: Slots[];
    // cards: KanbanCard[];
    // columns: Record<string, KanbanColumn>;
    columnOrder: string[];
    allDrivers: any[];
    allVehicles: any[];
  };
};
const initialState: InitialState = {
  isLoading: false,
  error: false,
  selectedDate: new Date(),
  board: {
    resources: [],
    jobs: [],
    slots: [],
    // cards: [],
    // columns: {},
    columnOrder: [],
    allDrivers: [],
    allVehicles: []
  }
};

const slice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    // START LOADING
    startLoading2(state) {
      state.isLoading = true;
    },
    stopLoading2(state) {
      state.isLoading = false;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    resetBoard2(state) {
      console.log('reset called');
      state.board = {
        resources: [],
        jobs: [],
        slots: [],
        // cards: [],
        // columns: {},
        columnOrder: [],
        allDrivers: state.board.allDrivers,
        allVehicles: state.board.allVehicles
      };
    },

    // HAS ERROR
    hasError2(state, action) {
      console.log('has error');
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET BOARD
    getBoardSuccess(state) {
      state.isLoading = false;
      // const board = action.payload;
      // const resources = state.board.resources;
      // const jobs = state.board.jobs;
      // const slots = state.board.slots;
      // const cards = board.cards;
      // const columns = objFromArray<KanbanColumn>(board.columns);
      // const { columnOrder } = board;
      // state.board = {
      //   resources,
      //   jobs,
      //   slots,
      //   cards,
      //   columns,
      //   columnOrder
      // };
    },
    // set drivers
    setResources(state, action) {
      const resourceList = action.payload;
      state.board.resources = resourceList;
    },
    setJobs2(state, action) {
      const jobList = action.payload.jobs;
      state.board.jobs = jobList;
      state.board.resources = action.payload.drivers;
    },

    setBoard2(state) {
      const resources = current(state.board.resources);
      let jobs = current(state.board.jobs);
      let slots: any = [];
      const result = Object.values(
        jobs.reduce((r: any, { driverID }) => {
          r[driverID] ??= { driverID, count: 0 };
          r[driverID].count++;
          return r;
        }, {})
      );
      const value = Math.max.apply(
        Math,
        result.map(function (o: any) {
          return o.count;
        })
      );
      // slots
      let foundJobsData: any = [];
      for (let i = 0; i < value; i++) {
        let slotData = resources.map((resource) => {
          const foundJob = jobs.find(
            (job) => !foundJobsData.includes(job) && job.driverID == resource.driverID
          );
          if (foundJob) {
            console.log(foundJob, 'foundJob');
            foundJobsData.push(foundJob);
            return foundJob;
          } else {
            return {
              client: '',
              clientAddress: '',
              docketType: '',
              driverID: 0,
              driverName: '',
              hazardous: false,
              jobID: 0,
              dayType: 0,
              jobStatus: 0,
              serviceDate: '',
              serviceDescription: '',
              serviceType: '',
              slotOrder: '',
              vehicleRegistration: '',
              vehicleType: '',
              wasteDetail: '',
              occurrenceFrom: '',
              occurrenceTo: ''
            };
          }
        });

        slots.push({
          slotName: i,
          data: slotData
        });

        // dispatch(slice.actions.getBoardSuccess());
      }
      state.board.slots = slots;
      console.log('has error');
      state.isLoading = false;
    },

    // CREATE NEW COLUMN
    createColumnSuccess(state, action) {},

    persistCard(state, action) {
      const columns = action.payload;
      // state.board.columns = columns;
    },

    persistColumn(state, action) {
      state.board.columnOrder = action.payload;
    },

    addTask(state, action) {
      const { card, columnId } = action.payload;

      // state.board.cards[card.id] = card;
      // state.board.columns[columnId].cardIds.push(card.id);
    },

    deleteTask(state, action) {
      const { cardId, columnId } = action.payload;

      // state.board.columns[columnId].cardIds = state.board.columns[columnId].cardIds.filter(
      //   (id) => id !== cardId
      // );
      // state.board.cards = omit(state.board.cards, [cardId]);
    },

    // UPDATE COLUMN
    updateColumnSuccess(state, action) {},

    // DELETE COLUMN
    deleteColumnSuccess(state, action) {},

    setDrivers(state, action) {
      state.board.allDrivers = action.payload;
    },
    setVehicles(state, action) {
      state.board.allVehicles = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const { actions } = slice;

// ----------------------------------------------------------------------
export function getVehiclesDrivers() {
  return async () => {
    try {
      const response: any = await axios.get(`/rest/api/driver/all`);
      const allDrivers = response.data.data.filter((item: any) => item.driverID !== -1);
      // state.board.allDrivers = allDrivers;
      dispatch(slice.actions.setDrivers(allDrivers));
    } catch (error) {
      dispatch(slice.actions.hasError2(error));
    }

    try {
      const response: any = await axios.get(`/rest/api/vehicle/all`);
      const allVehicles = response.data.data.filter((item: any) => item.driverID !== -1);
      // state.board.allDrivers = allDrivers;
      dispatch(slice.actions.setVehicles(allVehicles));
    } catch (error) {
      dispatch(slice.actions.hasError2(error));
    }
  };
}
export function getBoard(date: any, location: any, status: any) {
  return async () => {
    dispatch(slice.actions.resetBoard2());
    dispatch(slice.actions.startLoading2());
    try {
      const url = `/rest/api/job/all/1?currentDate=${date}${
        location !== '' ? `&location=${location}` : ''
      }${status !== 0 ? `&status=${status}` : ''}`;
      const response = await axios.get(url);
      if (response.data.success == false) {
        console.log('no data found');
        dispatch(slice.actions.stopLoading2());
      } else {
        console.log('data found');
        dispatch(slice.actions.setJobs2(response.data.data));
        try {
          dispatch(slice.actions.setBoard2());
        } catch (error) {
          dispatch(slice.actions.hasError2(error));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError2(error));
    }
  };
}
export function setUpdatedSelectedDate(date: any) {
  return async () => {
    dispatch(slice.actions.setSelectedDate(date));
  };
}

// ----------------------------------------------------------------------

export function createColumn(newColumn: { name: string }) {
  return async () => {
    dispatch(slice.actions.startLoading2());
    try {
      const response = await axios.post('/api/kanban/columns/new', newColumn);
      dispatch(slice.actions.createColumnSuccess(response.data.column));
    } catch (error) {
      dispatch(slice.actions.hasError2(error));
    }
  };
}

// ----------------------------------------------------------------------

// export function updateColumn(columnId: string, updateColumn: KanbanColumn) {
//   return async () => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.post('/api/kanban/columns/update', {
//         columnId,
//         updateColumn
//       });
//       dispatch(slice.actions.updateColumnSuccess(response.data.column));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

// ----------------------------------------------------------------------

export function deleteColumn(columnId: string) {
  return async () => {
    dispatch(slice.actions.startLoading2());
    try {
      await axios.post('/api/kanban/columns/delete', { columnId });
      dispatch(slice.actions.deleteColumnSuccess({ columnId }));
    } catch (error) {
      dispatch(slice.actions.hasError2(error));
    }
  };
}

// ----------------------------------------------------------------------

export function persistColumn(newColumnOrder: string[]) {
  return () => {
    dispatch(slice.actions.persistColumn(newColumnOrder));
  };
}

// ----------------------------------------------------------------------

// export function persistCard(columns: Record<string, KanbanColumn>) {
//   return () => {
//     dispatch(slice.actions.persistCard(columns));
//   };
// }

// ----------------------------------------------------------------------

// export function addTask({ card, columnId }: { card: Partial<KanbanCard>; columnId: string }) {
//   return () => {
//     dispatch(slice.actions.addTask({ card, columnId }));
//   };
// }

// ----------------------------------------------------------------------

export function deleteTask({ cardId, columnId }: { cardId: string; columnId: string }) {
  return () => {
    dispatch(slice.actions.deleteTask({ cardId, columnId }));
  };
}
